// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nodata-wrap[data-v-558a12c6]{width:100%;min-height:200px;display:flex;flex-direction:column;align-items:center;justify-content:center;span[data-v-558a12c6]{font-size:12px;margin-top:10px}}", ""]);
// Exports
module.exports = exports;
